var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var CustomerInformationController = /** @class */ (function () {
    function CustomerInformationController() {
    }
    /*****************************************************************************************************
        * Is using route "api/customerInformation/filtered/{groupId}/{countryCode?}/{contentLocationId?}/{categoryId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {string} contentLocationId
        * @param {string} categoryId
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.GetInformationElements = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/filtered/{groupId}/{countryCode?}/{contentLocationId?}/{categoryId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/allgroups/filtered/{countryCode?}/{contentLocationId?}/{categoryId?}" and http method "GET" to call the back-end.
    
        * @param {string} countryCode
        * @param {string} contentLocationId
        * @param {string} categoryId
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.GetInformationElementsForAllGroups = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/allgroups/filtered/{countryCode?}/{contentLocationId?}/{categoryId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/single/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {InformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.GetInformationElement = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/single/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {InformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.DeleteInformationElement = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/persona/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PersonaInformationElementUploadDto} persona
        * @param {File} profileImage
        * @param {{[key: string]: File}} otherImages
        * @returns {PersonaInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.UpdatePersona = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("persona", JSON.stringify(data.persona));
        if (data.profileImage)
            fd.append("profileImage", data.profileImage);
        _.forEach(data.otherImages, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/persona/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/data/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DataInformationElementUploadDto} data
        * @returns {DataInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.UpdateData = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/data/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/value/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ValueInformationElementUploadDto} data
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.UpdateValue = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/value/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/media/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {MediaInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.UpdateMedia = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/media/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/media/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {MediaInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {MediaInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.PostMedia = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/media/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/value/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {ValueInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.PostValue = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/value/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/persona/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportPersonaExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/persona/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/values/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {ValueInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportValuesExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/values/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportPssDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss18/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportPss18DataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss18/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportNcbsDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {NewsInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.GetNews = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {NewsInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @param {{[key: string]: File}} multipleMediaBytes
        * @returns {NewsInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.AddNews = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        _.forEach(data.multipleMediaBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {NewsInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @param {{[key: string]: File}} multipleMediaBytes
        * @returns {NewsInformationElementDownloadDto}
    ******************************************************************************************************/
    CustomerInformationController.UpdateNews = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        _.forEach(data.multipleMediaBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportCaPDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vp/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportVpDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vp/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pfs/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportPfsDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pfs/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/jdpower/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportJdPowerDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/jdpower/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/data/all/{groupId}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupId
        * @returns {void}
    ******************************************************************************************************/
    CustomerInformationController.DeleteAllDataElements = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/data/all/{groupId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vx/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportVxDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vx/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vci/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportVciDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vci/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/complaints/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    CustomerInformationController.ImportComplaintsDataExcel = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/complaints/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/hasNewData/{lastTime}/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {number} lastTime
        * @param {string} groupId
        * @returns {boolean}
    ******************************************************************************************************/
    CustomerInformationController.HasNewData = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/hasNewData/{lastTime}/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/sendPushNotification/{groupId}/{userId?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SendPushNotificationDto} data
        * @param {string} userId
        * @returns {string}
    ******************************************************************************************************/
    CustomerInformationController.SendPushNotification = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/sendPushNotification/{groupId}/{userId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    };
    /*****************************************************************************************************
        * Is using route "api/customerInformation/informationElement/stats/viewed" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {InformationElementViewedDto[]}
    ******************************************************************************************************/
    CustomerInformationController.GetInformationElementStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/informationElement/stats/viewed", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    return CustomerInformationController;
}());
export { CustomerInformationController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CustomerInformationController.js.map